import { useCallback } from 'react';
import { useFeedsStore } from './useFeedsStore';
import { FeedActionType } from '../../interfaces/store/feedStore';
import { IFeed } from '../../interfaces/models/feed';

export const useFeedsActions = () => {
    const { dispatch } = useFeedsStore();

    const setFeeds = useCallback((feeds: IFeed[]) => {
        dispatch({ type: FeedActionType.SET_FEEDS, payload: feeds });
    }, [dispatch]);

    const setFeedData = useCallback((feeds: IFeed[], numConnections?: number, maxNumConnections?: number) => {
        dispatch({ 
            type: FeedActionType.SET_FEED_DATA, 
            payload: { feeds, numConnections, maxNumConnections } 
        });
    }, [dispatch]);

    const addFeed = useCallback((feed: IFeed) => {
        dispatch({ type: FeedActionType.ADD_FEED, payload: feed });
    }, [dispatch]);

    const updateFeed = useCallback((id: string, updates: Partial<IFeed>) => {
        dispatch({ type: FeedActionType.UPDATE_FEED, payload: { id, updates } });
    }, [dispatch]);

    const deleteFeed = useCallback((id: string) => {
        dispatch({ type: FeedActionType.DELETE_FEED, payload: id });
    }, [dispatch]);

    const setLoading = useCallback((loading: boolean) => {
        dispatch({ type: FeedActionType.SET_LOADING, payload: loading });
    }, [dispatch]);

    const resetStore = useCallback(() => {
        dispatch({ type: FeedActionType.RESET_STORE });
    }, [dispatch]);

    return {
        setFeeds,
        setFeedData,
        addFeed,
        updateFeed,
        deleteFeed,
        setLoading,
        resetStore,
    };
};
